import { Locale } from '@headless-workspace/config';
import { Repository, Result, ResultFailureFromApiError, ResultSuccess } from '@headless-workspace/core-domain';
import {
    memoryCacheAuthStrategy,
    memoryCacheQueryParamStrategy,
    memoryCacheRefreshTokenStrategy,
} from '@headless-workspace/data';
import { CustomerGroupDTO } from './CustomerGroupsDTO';
import { mapCustomerGroups } from './CustomerGroupsValue';

const CUSTOMER_GROUPS_LIMIT = 1000;

export interface ShopTheFutureRepositorySpec {
    getCustomersGroups(locale: Locale, offset: number, limit?: number): Promise<Result<string[]>>;
}

export class ShopTheFutureRepository extends Repository implements ShopTheFutureRepositorySpec {
    path = '/settings/v1/';

    constructor() {
        super(memoryCacheAuthStrategy, memoryCacheRefreshTokenStrategy, memoryCacheQueryParamStrategy);
    }

    async getCustomersGroups(
        locale: Locale,
        offset: number,
        limit: number = CUSTOMER_GROUPS_LIMIT,
    ): Promise<Result<string[]>> {
        try {
            const response = await this.datasource.getResource(`${this.path}/customerGroups`, {
                locale,
                offset: offset.toString(),
                limit: limit.toString(),
            });

            const customerGroups = CustomerGroupDTO.parse(response);

            return ResultSuccess(mapCustomerGroups(customerGroups));
        } catch (error) {
            const apiError = this.handleApiError(error);
            return ResultFailureFromApiError(apiError, { locale });
        }
    }
}
